import type { LucideIcon } from "lucide-react";

export function CatalogSectionHeading(props: { children: string; icon: LucideIcon }) {
  const Icon = props.icon;
  return (
    <div className="flex items-center gap-3">
      <h2 className="flex items-center gap-2 text-[11px] font-semibold tracking-[0.08em] text-foreground uppercase">
        <span className="flex size-6 shrink-0 items-center justify-center rounded-md bg-muted text-muted-foreground">
          <Icon className="size-3.5" aria-hidden />
        </span>
        {props.children}
      </h2>
      <div className="h-px flex-1 bg-border/70" />
    </div>
  );
}
